import CloseIcon from '@mui/icons-material/Close';
import { Modal } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';

interface ViewRemarkModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function ViewRemark({ open, onClose, setOpen }: ViewRemarkModalProps) {
  return (
    <Modal
      className="modal remark_modal"
      id="ViewRemarkModal"
      aria-labelledby="ViewRemark-modal-title"
      aria-describedby="ViewRemark-modal-description"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="btn-close" onClick={() => setOpen(false)}>
            <CloseIcon />
          </div>
          <div className="modal_title">
            <h2>Remark</h2>
          </div>
          <div className="remark_detail">
            <div className="user_block">
              <figure>
                <img src="/static/images/user_attachment.jpg" alt="" />
              </figure>
              <p>Admin User</p>
            </div>
            <p>
              Lorem Ipsumis simply dummy text of the printing and typesetting industry. Lorem Ipsum
              has been the industry's standard dummy text ever since the 1500s, when an unknown
              printer took a galley of type and scrambled it to make a type specimen book. It has
              survived not only five centuries, but also the leap into electronic typesetting,
              remaining essentially unchanged. It was popularised in the 1960s with the release of
              Letraset sheets containing Lorem Ipsum passages, and more recently with desktop
              publishing software like Aldus PageMaker including versions of Lorem Ipsum.
            </p>
            <p>
              It is a long established fact that a reader will be distracted by the readable content
              of a page when looking at its layout. The point of using Lorem Ipsum is that it has a
              more-or-less normal distribution of letters, as opposed to using 'Content here,
              content here', making it look like readable English.
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );
}
